var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGirlBody7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 618,
    height: 704,
    viewBox: "0 0 618 704",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Girl / Body / 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Skin color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skin",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.242 488.709C478.242 488.709 455.638 491.549 451.336 501.667C439.03 530.607 464.53 582.345 464.53 582.345C464.53 582.345 453.726 575.753 451.576 581.517C450.618 584.083 448.45 604.581 488.93 605.959C493.228 606.107 503.566 597.365 503.566 597.365C503.566 597.365 496.028 611.759 507.57 614.585C507.57 614.585 526.172 586.715 526.458 580.513C526.742 574.309 520.772 542.915 517.544 536.575C514.316 530.233 478.242 488.709 478.242 488.709ZM95.4659 539.509L87.4579 489.719C76.5312 494.766 67.0967 494.35 59.2421 494.004C51.1743 493.648 44.7732 493.365 40.1339 499.153C30.8799 510.697 20.2319 534.407 14.6879 548.455C12.3979 554.255 11.0579 575.475 12.7859 587.471C13.7659 594.263 17.1379 600.919 17.1379 600.919C17.1379 600.919 20.5019 613.631 22.3379 614.963C27.5239 618.727 30.8359 613.323 30.8359 613.323C30.8359 613.323 32.1219 631.163 36.2199 630.029C38.7479 629.329 42.7079 626.601 43.4159 622.309C47.9279 594.989 57.4319 567.143 67.5639 563.563C74.0697 561.265 74.6994 572.354 75.289 582.736C75.6176 588.523 75.9337 594.09 77.2479 596.997C80.8099 604.873 98.1939 612.633 95.4399 599.369C91.6693 581.197 92.5624 573.919 93.8934 563.071C93.9567 562.555 94.021 562.031 94.0859 561.497C95.5159 549.743 95.4659 539.509 95.4659 539.509Z",
    fill: "#E576C6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    opacity: 0.152414,
    d: "M472.796 526.096C472.796 526.096 478.476 547.554 497.97 554.24C504.788 556.578 503.084 584.176 519.792 580.876",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Sweater color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Sweater",
    d: "M233.618 59.5829L239.351 17.9995L326.731 30.0475L321.966 64.6043C347.616 67.0813 365.078 72.0874 381.417 87.0893C433.897 135.269 437.757 315.629 437.757 315.629L493.217 505.129L447.577 510.849C447.577 510.849 371.177 409.609 354.297 355.169H197.797C197.797 355.169 199.277 338.989 195.597 315.609C190.757 285.029 173.377 262.229 173.377 262.229L141.937 300.909L87.4574 493.869L37.3974 502.849C37.3974 502.849 22.3774 345.109 52.7574 258.969C79.3174 183.629 127.777 101.809 165.617 77.9693C189.639 62.8277 212.204 59.5074 233.618 59.5829Z",
    fill: "#CE3D29"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 14",
    opacity: 0.195894,
    d: "M369.827 357.27C376.243 275.784 420.653 258.554 388.653 167.17",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 19",
    opacity: 0.195894,
    d: "M212.346 203.169L173.372 262.219",
    stroke: "black",
    strokeWidth: 3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlBody7);
export default __webpack_public_path__ + "static/media/Girl-Body-7.954feaaa.svg";
export { ForwardRef as ReactComponent };